<template>
	<div class="vue-events-plugin-wrap">
		<router-view />
	</div>
</template>

<script>
export default {
	data() {
		return {
			publicPath: (process.env.NODE_ENV === 'production') ? process.env.BASE_URL + 'wp-content/plugins/' + process.env.VUE_APP_PLUGIN_FOLDER + '/' : process.env.BASE_URL,
			useToggleSubstitutes: ('1' === process.env.VUE_APP_SUBSTITUTE_BS_TOGGLES || false) ? true : false,
		}
	},
	provide: {
		publicPath: (process.env.NODE_ENV === 'production') ? process.env.BASE_URL + 'wp-content/plugins/' + process.env.VUE_APP_PLUGIN_FOLDER + '/' : process.env.BASE_URL,
		useToggleSubstitutes: ('1' === process.env.VUE_APP_SUBSTITUTE_BS_TOGGLES || false) ? true : false,
	},
	inject: [
		'settings'
	]
}
</script>

<style lang="scss">
@import 'assets/app.scss';
</style>

<style lang="scss" scoped>
.vue-events-plugin-wrap {
	position: relative;
	min-height: 450px;
}
</style>
